export default __webpack_public_path__ + "8ad071f0cf022e24703709466f05bfb1.jpg";